import type { RutaProd } from '../../../../runtime/rutas';
export default {
  ruta: '/sistema/reportesbi/resumen',
  documento: 'reportesbi',
  acceso: 'sesion',
  filas: ['118'],
  cita: 'Areas/ReportesBI/Controllers/TablerosController.cs:35',
} satisfies RutaProd;
